import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import PurchasePaymentListLayer from "../components/PurchasePaymentListLayer";

const PurchasePaymentListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

   const locationId = localStorage.getItem('locationID')

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/purchase-payments?locationId=${locationId}`);
      const result = await res.json();
      setData(result);
    } catch (err) {
      console.error("Error fetching payments:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Purchase Payments - List" />
      {loading && <div className="text-center mt-4"><Spinner /></div>}
      {!loading && data?.length === 0 && (
        <div className="text-center mt-4"><p>No Payment data found....</p></div>
      )}
      {!loading && data?.length > 0 && <PurchasePaymentListLayer paymentsData={data} />}
    </MasterLayout>
  );
};

export default PurchasePaymentListPage;
